module.exports = __webpack_public_path__ + "static/img/cont53 (1).42f49b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont53 (1).jpg
// module id = IJrT
// module chunks = 0